import selectColorTypeEvent from "@/components/common/selectColorTypeEvent";
import { SITE_DOMAIN } from "@/constant";
import { format } from "date-fns";

export const EventInitialData = {
  payload: {
    name: "",
    design_colors_primary: selectColorTypeEvent[0].color,
    design_colors_button: selectColorTypeEvent[0].buttonColor,
    image: "",
    image_name: "",
    about: "",
    image_type: "",
    summary: "",
    image_path: "",
    company: "",
    headline: "",
    description: "",
    sale_badge: "10%",
    coupon_name: "",
    start_date: format(new Date(), "yyyy-MM-dd"),
    address: "",
    longitude: -73.9855426,
    latitude: 40.7579747,
    street: "",
    street_number: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    button: "Shop Now",
    button_url: "",
    barcode_image: "",
    barcode_path: "",
    welcome_screen: "",
    welcome_path: "",
    showUseBarCode: false,
    showMoreAddress: false,
    venue_amenities: [],
  },
};

export const EventAddButton = [
  {
    value: "Book now",
    icon: "",
  },
  {
    value: "Get tickets",
    icon: "",
  },
  {
    value: "Register",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];
